import React, { useState, useEffect, useCallback, useRef } from 'react';
import ChatInput from '../ChatInput';
import ChatMessages from '../ChatMessages';
import styles from './styles';
import moment from 'moment';
const HLSChat = ({ session, setShowNotificationChat, isOpen }) => {
  const [listOfMessages, setListOfMessages] = useState([]);
  const classes = styles();
  const prevArrayLength = useRef(listOfMessages.length);
  const [sendByMe, setSendByMe] = useState(false);
  // Callback to add a new message to the list
  const addMessageToList = useCallback((data, isSentByMe, from, date) => {
    // console.log('addMessageToList', data);
    setListOfMessages((prev) => [...prev, { data, isSentByMe, from, date }]);
  }, []);

  useEffect(() => {
    if (
      !isOpen &&
      listOfMessages.length > 0 &&
      listOfMessages.length > prevArrayLength.current
    ) {
      setShowNotificationChat(true);
    }
    prevArrayLength.current = listOfMessages.length;
  }, [isOpen, listOfMessages]);

  // Function to handle sending messages using session.signal
  const sendMessage = (text) => {
    setSendByMe(true);
    let userName = JSON.parse(sessionStorage.getItem('userData'));
    let texts = { text, name: userName.name };
    if (session) {
      session.signal(
        {
          type: 'text',
          data: texts,
        },
        (error) => {
          if (error) {
            console.error('Error sending signal:', error.message);
          } else {
            // const date = new Date().toISOString();
            // addMessageToList(text, true, 'Me', date); // Assuming 'Me' as sender
          }
        }
      );
    }
  };

  // Subscribe to incoming messages using session.on
  useEffect(() => {
    if (session) {
      session.on('signal:text', (event) => {
        const isSentByMe =
          event.from.connectionId === session.connection.connectionId;
        const date = moment(new Date().getTime()).format('HH:mm');
        let from = { name: event.data.name };
        addMessageToList(event.data.text, isSentByMe, from, date);
      });
    }

    // Clean up the event listener when the component is unmounted
    return () => {
      if (session) {
        session.off('signal:text');
      }
    };
  }, [session, addMessageToList]);

  return (
    <div className={classes.chatContainer}>
      <ChatMessages
        chatClass={classes.chatMessages}
        chatMessages={listOfMessages}
      />
      <div className={classes.chatInput}>
        <ChatInput sendMessage={sendMessage} />
      </div>
    </div>
  );
};

export default HLSChat;
